export { tableVariables as tableCellVariables } from './tableVariables';
